<p-card [style]="{ borderLeft: esInicial ? '4px solid var(--primary-color)' : (!completo ? '4px solid var(--yellow-500)' : undefined) }">
    <ng-template pTemplate="header">
        <div class="flex align-items-center justify-content-between px-3 pt-3">
            <span class="flex align-items-center gap-2">
                <i class="pi pi-bars text-300 drag-handle cursor-move" cdkDragHandle title="Arrastrar para reordenar"></i>
                <span class="font-semibold">{{ titulo }}</span>
            </span>
            <span class="flex align-items-center gap-2 text-500">
                <i [class]="icono"></i>
                <small>{{ subtitulo }}</small>
            </span>
        </div>
    </ng-template>

    <p class="m-0" *ngIf="textoPreview">{{ textoPreview }}</p>
    <p class="text-500 font-italic m-0" *ngIf="!textoPreview">Todavía sin texto</p>

    <ul class="list-none p-0 mt-2 mb-0" *ngIf="opciones.length">
        <li *ngFor="let opcion of opciones" class="text-500 text-sm mb-1">
            <i class="pi pi-angle-right"></i> {{ opcion.etiqueta || opcion.id }}
        </li>
    </ul>

    <div class="mt-2" *ngIf="!completo">
        <p class="text-yellow-700 text-sm m-0 mb-1" *ngFor="let falta of faltantes">
            <i class="pi pi-exclamation-circle"></i> {{ falta }}
        </p>
    </div>

    <p class="text-green-600 text-sm mt-2 mb-0" *ngIf="completo">
        <i class="pi pi-check-circle"></i> Listo
    </p>

    <ng-template pTemplate="footer">
        <div class="flex justify-content-end gap-2">
            <button pButton type="button" icon="pi pi-pencil" label="Editar" class="p-button-text p-button-sm" (click)="editar.emit()"></button>
            <button *ngIf="!esInicial" pButton type="button" icon="pi pi-trash" label="Quitar" class="p-button-text p-button-danger p-button-sm" (click)="eliminar.emit()"></button>
        </div>
    </ng-template>
</p-card>
